import type { TColor } from '@Theme';
import OwnableTheme from '@Theme';
import type { FC } from 'react';
import React from 'react';
import type { StyleProp, TextStyle } from 'react-native';
import { StyleSheet, View } from 'react-native';

import type { Size, Weight } from '../../Common/Text';
import { Text } from '../../Common/Text';

type ProductRrpProps = {
  rrp: number | null | undefined;
  unit?: string | null;
  weight?: Weight;
  size?: Size;
  gutterBottom?: number;
  color?: TColor;
};

const labelStyle: StyleProp<TextStyle> = {
  display: 'flex',
  alignItems: 'flex-end',
  alignSelf: 'center',
  height: '100%',
  justifyContent: 'center',
  marginLeft: '15px',
  lineHeight: 24,
};

const ProductRrp: FC<ProductRrpProps> = ({
  weight = 'regular',
  rrp,
  color = OwnableTheme.colors.persianIndigo,
  size = 'ml',
}) => {
  if (!rrp || rrp < 0) {
    return null;
  }

  return (
    <View>
      <Text
        weight={weight}
        size={size}
        color={color}
        fontStyleOverride={labelStyle}
      >
        RRP:{' '}
        <Text
          fontStyleOverride={styles.text}
          weight={weight}
          size={size}
          color={color}
        >
          £{rrp.toFixed(2)}
        </Text>
      </Text>
    </View>
  );
};

export default ProductRrp;

const styles = StyleSheet.create({
  text: { textDecorationLine: 'line-through' },
});
